<div class="max-h-[720px] overflow-y-auto px-12 py-16 custom-scrollbar">

  <!-- Timeline Container -->
  <!-- <div *ngIf="!hasVinculation" class="flex justify-center items-center py-12">
    <p class="text-m text-eggplant-100/[0.55]">*En función a tus datos, no perteneces a ningún grupo prioritario. Si
      cuentas con alguna
      dirección que coincida con las direcciones elegibles para los grupos prioritarios de este proyecto, puedes
      añadirlas en tu área personal. <span (click)="goToAddAddress()" class="cursor-pointer text-orange-100">Ir a mi
        área personal.</span></p>
  </div> -->
  <div class="flex flex-col relative">

    <!-- Timeline Groups Loop -->
    <div *ngFor="let group of groupedPriorityGroups; let isLast = last; let i = index" class="relative pb-16 last:pb-0">

      <!-- Vertical Connector Line -->
      <div *ngIf="!isLast" class="absolute left-[13px] top-[28px] bottom-0 w-[2px] bg-gray-10">
      </div>

      <!-- Priority Node & Items -->
      <div class="flex gap-10">

        <!-- Timeline Marker (Circle with Number) -->
        <div class="relative z-10 flex-shrink-0">
          <div
            class="flex items-center justify-center w-28 h-28 rounded-full bg-orange-100 transition-all duration-300 absolute">
            <span class="text-m font-sans text-white leading-none">{{ group.priority }}</span>
          </div>
        </div>

        <!-- Group Content -->
        <div class="flex flex-col gap-12 w-full pb-16 pl-24">

          <!-- Individual Items within this Priority Group -->
          <div *ngFor="let pg of group.items" class="flex flex-col gap-6">

            <!-- Item Main Header/Title -->
            <div class="flex flex-col gap-2">
              <div class="flex justify-between items-start gap-4">
                <h3 class="text-xl font-sans text-eggplant-100 leading-tight">
                  {{ pg.name }}
                </h3>

                <!-- "Tu grupo" Badge - Solo se muestra en el grupo más prioritario -->
                <div *ngIf="pg.isEnabledForUser && pg.priority === highestUserPriority"
                  class="flex items-center gap-4 px-6 py-2 rounded-full bg-verified text-white whitespace-nowrap">
                  <span class="text-xs font-sans uppercase pt-2">Tu grupo</span>
                  <fun-icon [name]="'user-check'" [style]="'w-12 h-12 stroke-[4px] stroke-white'"></fun-icon>
                </div>
              </div>
              <p class="text-m font-sans text-eggplant-100 opacity-60 leading-relaxed">
                {{ pg.description }}
              </p>
            </div>

            <!-- Codes/Values Accordion -->
            <div *ngIf="pg.value && pg.type !== 2"
              class="rounded-xl bg-gray-10/40 border border-gray-10 overflow-hidden">
              <!-- Accordion Header -->
              <div (click)="toggleExpand(pg.id)"
                class="flex items-center justify-between px-12 py-8 cursor-pointer hover:bg-gray-10/60 transition-colors duration-200">
                <span class="text-s font-sans text-eggplant-100/[0.7]">Ver códigos ({{ parseValues(pg.value).length
                  }})</span>
                <fun-icon [name]="'chevron-down'"
                  [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100/[0.5] transition-transform duration-500 ' + (isExpanded(pg.id) ? 'rotate-180' : '')"></fun-icon>
              </div>
              <!-- Accordion Content -->
              <div *ngIf="isExpanded(pg.id)" class="px-12 pb-12 pt-4">
                <div class="grid grid-cols-4 md:grid-cols-6 gap-6 justify-items-center">
                  <span *ngFor="let code of parseValues(pg.value)"
                    class="w-full text-center px-8 py-4 rounded-lg bg-white border border-eggplant-100/[0.1] text-s font-sans font-mono text-eggplant-100/[0.8]">
                    {{ code }}
                  </span>
                </div>
              </div>
            </div>
            <div *ngIf="!pg.isEnabledForUser" class="flex flex-col justify-center items-center">
              <p class="text-s font-sans text-eggplant-100/[0.55]">*Si crees que perteneces a este
                grupo
                prioritario, puedes probar tu vinculación
                <span *ngIf="pg.type === 1"> o añadir una dirección elegible </span>
              </p>
              <div class="flex items-center gap-4 pt-6">
                <fun-new-button size="s" icon="" iconPosition="" buttonType="primaryDark" title="Probar vinculación"
                  (eventClick)="vinculate(stage)"></fun-new-button>
                <fun-new-button *ngIf="pg.type === 1" size="s" icon="" iconPosition="" buttonType="secondaryDark"
                  title="Añadir otra dirección" (eventClick)="goToAddAddress()"></fun-new-button>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>